module.exports = __webpack_public_path__ + "static/media/2023-02-09-slider-2.d0ad9456.jpg";